import loadable from '@loadable/component';

export const TechradarSiteWrapper = loadable(
  () => import(/* webpackChunkName: "techradar-site" */ './TechradarSiteWrapper'),
);
